import React, { useRef, useState } from "react";
import { Checkbox, Input, Select } from "antd";
import { useTranslation } from "react-i18next";
import LocationMapInput from "./LocationMapInput";
import { searchSharedDirectory } from "../services/fleetDirectoryService";

export default function LocationForm({ value = {}, onChange, fleetId, editing = false, suggestInitialAddress = false, showErrors = false }) {
  const { t } = useTranslation();
  const [suggestions, setSuggestions] = useState([]);
  const [searchError, setSearchError] = useState(false);
  const request = useRef(0);
  const update = patch => onChange({ ...value, ...patch });
  const [touched, setTouched] = useState({});
  const errorFor = key => (showErrors || touched[key]) &&
    (key === "name" ? !String(value.name || "").trim() : !value.roles?.length) ? t(`placeForm.${key}`) : "";
  const field = (key, control) => <label style={{ display: "grid", gap: 5 }}>{t(`directory.${key}`)}{control}</label>;
  return <div style={{ display: "grid", gap: 12 }}>
    {!editing && field("sharedSuggestion", <Select showSearch allowClear filterOption={false}
      status={searchError ? "error" : undefined} title={searchError ? t("placeForm.searchError") : undefined}
      onSearch={async query => {
        const token = ++request.current;
        setSearchError(false);
        if (query.trim().length < 2) { setSuggestions([]); return; }
        try { const results = await searchSharedDirectory(fleetId, query, "LOCATION"); if (token === request.current) setSuggestions(results); }
        catch { if (token === request.current) { setSuggestions([]); setSearchError(true); } }
      }}
      options={suggestions.map(item => ({ value: item.id, label: `${item.name} — ${item.address?.streetName || ""}` }))}
      onChange={id => {
        const item = suggestions.find(s => s.id === id);
        if (!item) { update({ globalLocationId: "" }); return; }
        update({ name: item.name, roles: Array.from(new Set([...(value.roles || []), ...(item.roles || [])])),
          ...item.address, latitude: item.latitude ?? null, longitude: item.longitude ?? null, globalLocationId: item.id });
      }} />)}
    {field("name", <Input status={errorFor("name") ? "error" : undefined} title={errorFor("name") || t("directory.name")} onBlur={() => setTouched(prev => ({ ...prev, name: true }))} value={value.name || ""} onChange={e => update({ name: e.target.value })} />)}
    {field("roles", <div title={errorFor("roles")} style={errorFor("roles") ? { outline: "1px solid #ff4d4f", borderRadius: 6, padding: 4 } : undefined}><Checkbox.Group value={value.roles || []} onChange={roles => { setTouched(prev => ({ ...prev, roles: true })); update({ roles }); }}
      options={["PICKUP", "DROPOFF"].map(role => ({ value: role, label: t(`directory.role.${role}`) }))} /></div>)}
    <LocationMapInput value={value} onChange={onChange} suggestInitialAddress={suggestInitialAddress} showErrors={showErrors} />
    {field("instructions", <Input.TextArea rows={3} value={value.instructions || ""} onChange={e => update({ instructions: e.target.value })} />)}
    {!editing && <Checkbox checked={value.sharePublicDetails !== false} onChange={e => update({ sharePublicDetails: e.target.checked })}>{t("directory.sharePublicDetails")}</Checkbox>}
  </div>;
}
